import styled from 'styled-components'

export const PopupContentUi = styled.div`
  min-height: 100px;
  max-height: inherit;
`
